// extracted by mini-css-extract-plugin
module.exports = {"card":"categories_card__3G8MM","tag":"categories_tag__1xFZg","titleFilter":"categories_titleFilter__27-Yv"};